import axios from "axios";
import {
  REACT_APP_APPLICATION_ENVIRONMENT,
  REACT_APP_PRODUCTION_URL,
  REACT_APP_STAGING_URL,
  REACT_APP_DEVELOPMENT_URL,
} from "../../Utils/Constant";

const getEnvironmentUrl = () => {
  switch (REACT_APP_APPLICATION_ENVIRONMENT?.toUpperCase()) {
    case "DEVELOPMENT":
      return REACT_APP_DEVELOPMENT_URL;
    case "STAGING":
      return REACT_APP_STAGING_URL;
    case "PRODUCTION":
    default:
      return REACT_APP_PRODUCTION_URL;
  }
};

export const getBaseUrl = () => getEnvironmentUrl(); 